import { useRef } from 'react';
import type { HighwayMaintenanceFeePenaltyTicketSummary } from '#/components/ui/tickets/highway-maintenance-fee-penalty/model';

export type ChargeFailDialogConfirmValue = { afterDays: number };

export type ChargeFailDialogRef = {
  confirm: (
    ticket: HighwayMaintenanceFeePenaltyTicketSummary,
    amount: number,
  ) => Promise<ChargeFailDialogConfirmValue | undefined>;
  days: number | undefined;
};

export const useChargeFailDialog = () => {
  const modalRef = useRef<ChargeFailDialogRef>(null);
  const open = (
    ticket: HighwayMaintenanceFeePenaltyTicketSummary,
    amount: number,
  ) => modalRef.current?.confirm(ticket, amount);
  return { props: { modalRef }, open };
};
